import '../Modal.scss';
import './TransferTicketModalView.scss';
import { AttendantStatus } from '../attendantStatus';
export class TransferTicketModalController {
    static $inject = ['$translate', 'close', 'ticket', 'teams', 'attendants', 'isAttendantTransferEnabled', 'canTransferWithoutAgents', '$rootScope'];
    constructor($translate, close, ticket, teams, attendants, isAttendantTransferEnabled, canTransferWithoutAgents, $rootScope) {
        'ngInject';
        this.$translate = $translate;
        this.close = close;
        this.ticket = ticket;
        this.isAttendantTransferEnabled = isAttendantTransferEnabled;
        this.canTransferWithoutAgents = canTransferWithoutAgents;
        this.$rootScope = $rootScope;
        this.selectedItem = undefined;
        this.isTeam = true;
        this.onSelectedItemUpdate = async (event) => {
            this.selectedItem = event.detail?.value;
            await this.isInvalidTeam();
        };
        this.updateTeam = () => {
            this.isTeam = !this.isTeam;
            this.setCurrentList();
            this.selectedItem = undefined;
            this.$rootScope.$apply();
        };
        this.closeModal = () => {
            this.close({
                recipient: this.selectedItem,
                isTeam: this.isTeam,
            });
        };
        this.init(teams, attendants);
    }
    async init(teams, attendants) {
        if (!this.ticket) {
            this.close();
        }
        await this.fillTeams(teams);
        await this.fillAttendants(attendants);
        this.setCurrentList();
    }
    setCurrentList() {
        this.currentList = this.isTeam ? JSON.stringify(this.teams) : JSON.stringify(this.attendants);
    }
    async fillTeams(teams) {
        const teamPromises = teams.map(async (team) => {
            return {
                label: team.name,
                value: team.name,
                isActive: team.agentsOnline > 0,
                status: team.agentsOnline === 1
                    ? await this.$translate('transferTicket.select.agentAvailable', { count: team.agentsOnline })
                    : await this.$translate('transferTicket.select.agentsAvailable', { count: team.agentsOnline }),
            };
        });
        this.teams = await Promise.all(teamPromises);
    }
    async fillAttendants(attendants) {
        const attendantPromises = attendants ? attendants.map(async (attendant) => {
            const isActive = attendant.status === AttendantStatus.ONLINE;
            return {
                value: attendant.identity,
                label: attendant.fullName || attendant.email.split('@')[0],
                isActive,
                status: isActive
                    ? await this.$translate('transferTicket.select.attendantOnline')
                    : await this.$translate('transferTicket.select.attendantAbsent'),
            };
        }) : [];
        this.attendants = await Promise.all(attendantPromises);
    }
    async isInvalidTeam() {
        if (this.selectedItem && !this.canTransferWithoutAgents) {
            if (this.isTeam) {
                this.selectedItemIsInvalid = !this.teams.find(team => team.value === this.selectedItem).isActive;
            }
            else if (!this.isTeam) {
                this.selectedItemIsInvalid = !this.attendants.find(attendant => attendant.value === this.selectedItem).isActive;
            }
            if (this.selectedItemIsInvalid) {
                this.invalidTooltipText = this.isTeam ? await this.$translate('transferTicket.tooltip.error.teamWithoutOnlineAgents') : await this.$translate('transferTicket.tooltip.error.offlineAgents');
                return;
            }
        }
        this.selectedItemIsInvalid = false;
    }
}
TransferTicketModalController.$inject = ['$translate', 'close', 'ticket', 'teams', 'attendants', 'isAttendantTransferEnabled', 'canTransferWithoutAgents', '$rootScope'];
